<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <paginated-table :id="$attrs['id']"
                   :hover="false"
                   :draggable="showDragHandle"
                   :rows="transactions"
                   :items-per-page="20"
                   :columns="`${3 + (showDragHandle ? 1 : 0)}`"
                   min-width="500px">
    <template slot="table-head">
      <div v-if="showDragHandle" class="hm-table__th"></div>
      <div class="hm-table__th">{{ $t('table.transferTransactionTable.chargePeriod') }}</div>
      <div class="hm-table__th">{{ $t('table.transferTransactionTable.label') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transferTransactionTable.totalAmount') }}</div>
    </template>
    <template v-slot:default="slotProps">
      <template v-for="trans in slotProps.currentPage">
        <div v-if="showDragHandle" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">
          <span v-tooltip="{ title: $t('table.transferTransactionTable.dragForTransfer'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                draggable="true"
                class="grippy"
                @dragstart="dragstart($event, trans)"
                @dragover.prevent
                @dragenter="dragenter($event, trans)"
                @dragleave="dragleave($event, trans)"
                @dragend="dragend($event, trans)"
                @drop="drop($event, trans)"></span>
        </div>
        <div v-if="!isEmpty(trans.chargePeriod) && !isNil(trans.chargePeriod.startDate) && !isNil(trans.chargePeriod.endDate)" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">{{ trans.chargePeriod.startDate | toDate }} - {{ trans.chargePeriod.endDate | toDate }}</div>
        <div v-else :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">{{ trans.businessDate | toDate }}</div>
        <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">{{ trans.label }}{{ additionalLabel(trans) }}</div>
        <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td text-right">{{ trans.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <template v-for="childTrans in trans.childTransactions">
          <template v-if="childTrans.includedInParent === false">
            <div v-if="draggable" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td"></div>
            <div v-if="!isEmpty(childTrans.chargePeriod) && !isNil(childTrans.chargePeriod.startDate) && !isNil(childTrans.chargePeriod.endDate)" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td">{{ childTrans.chargePeriod.startDate | toDate }} - {{ childTrans.chargePeriod.endDate | toDate }}</div>
            <div v-else :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td">{{ childTrans.businessDate | toDate }}</div>
            <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td">{{ childTrans.label }}</div>
            <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td text-right">{{ childTrans.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
          </template>
        </template>
      </template>
      <template v-if="showDragHandle">
        <div v-for="trans in transactions" :id="`dragImage-${trans.id}`" style="width: auto;max-width:100vw;position:fixed;left:200vw;font-size: 1.4rem;">
          <table style="width:100%;">
            <tr>
              <td v-if="!isEmpty(trans.chargePeriod)" style="padding: 5px 10px 5px 5px;">{{ trans.chargePeriod.startDate | toDate }} - {{ trans.chargePeriod.endDate | toDate }}</td>
              <td v-else style="padding: 5px 10px 5px 5px;">{{ trans.businessDate | toDate }}</td>
              <td style="padding: 5px 10px;">{{ trans.label }}{{ additionalLabel(trans) }}</td>
              <td style="padding: 5px 5px 5px 10px;" class="text-right">{{ trans.amount | toCurrency }} {{ hotelSettings.details.currency }}</td>
            </tr>
          </table>
        </div>
      </template>
    </template>
  </paginated-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last } from 'lodash';
import TransactionTable from './TransactionTable';

export default {
  name: 'TransferTransactionTable',

  extends: TransactionTable,

  mixins: [HotelmeisterMixin],

  props: {
    draggable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    hasChildTrans(trans) {
      return isNil(trans.childTransactions) ? false : trans.childTransactions.filter(it => it.includedInParent === false).length > 0;
    },
    isLastChildTrans(trans, childTrans) {
      return last(trans.childTransactions.filter(it => it.includedInParent === false)) === childTrans;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  span.grippy {
    content: '....';
    width: 20px;
    height: 25px;
    white-space: normal;
    font-weight: normal;
    display: inline-block;
    overflow: hidden;
    line-height: 5px;
    padding: 3px 4px;
    cursor: move;
    vertical-align: middle;
    margin-top: -.7em;
    margin-right: .3em;
    font-size: 12px;
    font-family: sans-serif;
    letter-spacing: 2px;
    color: #cccccc;
    text-shadow: 1px 0 1px black;
    pointer-events: all;
  }
  span.grippy::after {
    content: '.. .. .. ..';
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/table/TransferTransactionTable.vue